import { useCallback, useMemo } from 'react';

import { useDispatch } from 'react-redux';

import { EditorProps } from 'src/components/bbc-atlaskit-editor';

import { handleImageUpload } from '../bitbucket-image-upload-handler';

export function useLegacyImageUploadProvider(): EditorProps['legacyImageUploadProvider'] {
  const dispatch = useDispatch();
  const imageUploadHandler = useCallback(
    (event, editorCallback) =>
      // This event could probably be cast as ClipboardEvent | DragEvent but our image upload handler
      // types would need additional refactoring to get it all working
      // @ts-ignore
      dispatch(handleImageUpload(event, editorCallback)),
    [dispatch]
  );

  const legacyImageUploadProvider = useMemo(
    () => Promise.resolve(imageUploadHandler),
    [imageUploadHandler]
  );

  return legacyImageUploadProvider;
}
